'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  tabs: {
    backgroundColor: 'white',
    selectedTextColor: '#00bcd4',
    textColor: '#757575'
  },
  inkBar: {
    backgroundColor: '#00bcd4'
  }
};
module.exports = exports['default'];